import {DATA_REQUEST_ACTION, DATA_RECEIVED_ACTION, DATA_FAIL_ACTION, SET_MAP_DATA_ACTION, SET_MAP_VIEWPORT_ACTION, START_OVER_MAP, SET_MAP_ZOOM, SET_MAP_CENTER, SET_DEFAULT_VIEWPORT_MAP} from "../actions/DataAction";
import {hydrateLoadedData, updateSearch} from "../helpers/sqlHelper";
import {getMapLegendLabels, getMapColorScale, getLegendColorScale} from "../helpers/formatters";

import initialStateData from "./initialStateData";

export default (state = initialStateData, action) => {
  switch (action.type) {

    case DATA_REQUEST_ACTION:
      state.loadingList.push(action.payload);
      return {
        ...state,
        loadingList: [...state.loadingList],
        loadingMax: state.loadingMax + 1,
        loading: true
      };

    case DATA_RECEIVED_ACTION:

      // Create/Update group
      let groupObject = state.data[action.payload.group] ? state.data[action.payload.group] : {};
      groupObject[action.payload.key] = action.payload.data;

      // Calculate loading List
      let newLoadingList = state.loadingList.filter(function (obj) {
        return obj.key !== action.payload.key;
      });

      // Update State
      let newState = {
        ...state,
        loading: newLoadingList.length === 0 ? false : true,
        loadingMax: newLoadingList.length === 0 ? 0 : state.loadingMax,
        loadingList: [...newLoadingList],
        data: {
          ...state.data,
          [action.payload.group]: groupObject
        },
        error: ""
      };

      // Hydrate if needed
      let hydrated = hydrateLoadedData(newState);
      if (hydrated.changed){
        newState = hydrated.state;
        //console.log('Something hydrated!', newState);
      }

      // Fill search table if needed
      let searchUpdated = updateSearch(action.payload.key, newState);
      if (hydrated.searchUpdated) {
        newState = searchUpdated.state;
        //console.log('Search updated!', newState);
      }

      return newState

    case DATA_FAIL_ACTION:
      return {
        ...state,
        loading: false,
        loadingMax:0,
        error: action.payload.error
      };

    case SET_MAP_DATA_ACTION:
      //Geojson
      let geojson = state.map.geojsonOptions[action.payload.view];
      if (!geojson){
        return state; //Not ready
      }
      //Map style
      const mapStyle = {...state.map.styleOptions[action.payload.view]};

      //Override filter
      if (action.payload.filter){
        mapStyle.filter = action.payload.filter;
      } else {
        delete mapStyle.filter;
      }

      let type;
      if (mapStyle.paint['fill-color']){
        type = 'fill-color';
      }
      if (mapStyle.paint['circle-color']){
        type = 'circle-color';
      }

      if (action.payload.field){
        let colorPalette = getMapColorScale(action.payload.view, action.payload.field);

        mapStyle.paint = {
          ...mapStyle.paint,
          [type]: {
            ...mapStyle.paint[type],
            property: action.payload.field,
            stops: colorPalette
          }
        }
      }

      let legendItems = getLegendColorScale(action.payload.view, action.payload.field, mapStyle.paint[type].stops);

      return {
        ...state,
        map:{
          ...state.map,
          geojson: geojson,
          style: mapStyle,
          legend: {
            ...getMapLegendLabels(action.payload.view, action.payload.field, action.payload.entity),
            items: legendItems
          }
        }
      };

    case SET_MAP_VIEWPORT_ACTION:
      return {
        ...state,
        map: {
          ...state.map,
          viewport: action.payload.viewport
        }
      };


    case START_OVER_MAP:
      return {
        ...state,
        map:{
          ...state.map,
          viewport: {...state.map.defaultViewport}
        }
      };

    case SET_DEFAULT_VIEWPORT_MAP:
      return {
        ...state,
        map: {
          ...state.map,
          defaultViewport: {...action.payload.viewport},
          viewport: {...action.payload.viewport}
        }
      };

    case SET_MAP_ZOOM:
      let newZoom = (action.payload.zoomIn) ? state.map.viewport.zoom + .25 : state.map.viewport.zoom - .25
      if (newZoom < state.map.viewport.minZoom){
        newZoom = state.map.viewport.minZoom;
      }
      if (newZoom > state.map.viewport.maxZoom) {
        newZoom = state.map.viewport.maxZoom;
      }
      return {
        ...state,
        map: {
          ...state.map,
          viewport: {
            ...state.map.viewport,
            zoom: newZoom
          }
        }
      };

    case SET_MAP_CENTER:
      const item = action.payload.item;
      const centerParams = item.type === "Cluster" || item.type === "ISCO" ? state.map.defaultViewport : {latitude: item.lat, longitude:item.lng, zoom:6};
      return {
        ...state,
        map: {
          ...state.map,
          viewport: {
            ...state.map.viewport,
            zoom: centerParams.zoom,
            latitude: centerParams.latitude,
            longitude: centerParams.longitude
          }
        }
      };

    default:
      return state;
  }
};
